import {Col, Row} from "antd";
import React, {useState} from "react";
import KycModal_1 from "../../../pages/accountVerification/view/layout_2/component/kycModal";
import {useRecoilValue} from "recoil";
import {globalBreadCrumbState,} from "../../../_common/global_state";
import {useTranslation} from "react-i18next";
import useShared from "../../../_common/_shared";

export const Breadcrumb_1 = ({kybList, poiList, porList}) => {
    const {t} = useTranslation();
    const {IconModule} = useShared();

    const [openKycModal, setOpenKycModal] = useState(false);

    const globalBreadCrumb = useRecoilValue(globalBreadCrumbState);

    const pageHeader = globalBreadCrumb[globalBreadCrumb?.length - 1];

    return (
        <Row className={"page-layout"}>
            <Col span={24} className={"mb-4 mt-4"}>
                <div className={"pageHeaderTitle"}>
                    <IconModule
                        iconName={`md-${pageHeader?.name?.replace(".", "").replace(/[-\s+]/g, "").toLowerCase()}`}
                        layout={1}
                        isAlwaysActive
                    />
                    <div>
                        {t(`module.${pageHeader?.name?.replace(".", "").replace(/[-\s+]/g, "_").toLowerCase()}`)}
                    </div>
                </div>
            </Col>
            <KycModal_1
                isModalOpen={openKycModal}
                handleCancel={() => setOpenKycModal(false)}
                verificationType={"kyb"}
                data={kybList}
                poiList={poiList}
                porList={porList}
            />
        </Row>
    );
};
